export const toDUCsWithNames = (ducIds: string[], ducs: Models.DtecApi.Duc[] | undefined): string => {
    const res = ducIds.map((id) => {
        const name = ducs?.find((duc) => duc.id === id)?.name || null;

        return name ? `${name} (${id})` : id;
    }).join(', ');

    return res;
};
